import { render, staticRenderFns } from "./returnPolicy.vue?vue&type=template&id=d9a116ee&scoped=true"
var script = {}
import style0 from "./returnPolicy.vue?vue&type=style&index=0&id=d9a116ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a116ee",
  null
  
)

export default component.exports